module.exports = __webpack_public_path__ + "da38cb80813eedce03b900cbbc4746e9.png";